import { z } from 'zod/v4-mini';

import { GeneralBackendResponseSchema } from '$/services/mapper/authentication';

export const CountrySchema = z.object({
  id: z.string(),
  isBrand: z.boolean(),
  languages: z.array(z.string()),
  mainLanguage: z.optional(z.string()),
  contactEmail: z.string(),
});

export const CountryDetailSchema = z.object({
  id: z.string(),
  inspirationIds: z.array(z.string()),
  collectionIds: z.array(z.string()),
  producerIds: z.array(z.string()),
});

export type Country = z.infer<typeof CountrySchema>;

export const GetAllCountriesSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.array(CountrySchema),
});

export const GetCountryByIdSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: CountryDetailSchema,
});
